import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=d16ade86&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"
import style0 from "./Collection.vue?vue&type=style&index=0&id=d16ade86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16ade86",
  null
  
)

export default component.exports